var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.468,
    height: 10.241,
    viewBox: "0 0 13.468 10.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-checkmark",
    "data-name": "Icon ionic-md-checkmark",
    d: "M8.789,15.8,5.622,12.626,4.5,13.7l4.289,4.28L17.968,8.8l-1.122-1.07Z",
    transform: "translate(-4.5 -7.734)",
    fill: "#4b96cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlueIcon);
export default __webpack_public_path__ + "static/media/checkBlueIcon.80265cf13833469593384b6fa6c696a3.svg";
export { ForwardRef as ReactComponent };